import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {DataManagementService} from '../services/data-management.service';
import {Course} from '../model/course';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.css']
})
export class CourseComponent implements OnInit {
  courses: Course[];
  errorMessage = 'You do not have any courses yet.';
  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};


  constructor(private dmService: DataManagementService) { }

  getCourses(): void {
    this.dmService.getCourses().subscribe(courses => {
      this.courses = courses.data;
      this.dtTrigger.next();
    });
  }

  ngOnInit() {
    this.getCourses();
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false
    };
  }

}
